export const projectedPayout = (betAmount: number, odds: number) => {
  return betAmount * odds;
};
